import React from 'react';
import UserContentMenu from './UserContentMenu';
import ElbenWaldContentMenu from './ElbenWaldContentMenu';
import ElbenWaldContentMenuMobile from './ElbenWaldLogo';

const UserContent = ({
    programOverviewUrl,
    affiliateSlug,
    translation,
    features
}) => (
    <div className='user-content-container'>
        <div className='grid-site-wrapper'>
            <UserContentMenu
                hasLogin={false}
                affiliateSlug={affiliateSlug}
                features={features}
                hasConcessionShop={false}
                hasVoucherShop={false}
                translation={translation}
                programOverviewUrl={programOverviewUrl}
            />
        </div>
    </div>
)

export default UserContent
